<script>
  export let openAbout;
</script>

<div class="absolute top-0 right-0 flex pv2">
  <button class="mr2" on:click={openAbout()}
    ><img src="./icones/more.svg" alt="" /></button
  >
</div>

<style>
  button {
    background-color: transparent;
    width: 48px;
    height: 48px;
    padding: 0;
  }
  img {
    padding: 0;
    margin: 0;
    width: 48px;
    height: 48px;
  }
</style>
